function renderPreorderBadge(){
  document.querySelectorAll('[data-preorder-release-prop]').forEach(element => {
    const preorderTag = element.dataset.preorderReleaseProp.split("@");
    const preorderDate = parseRawDateToDate(preorderTag[1],true);
    element.innerHTML = "Pre-order · Tersedia " + preorderDate;
  });
}

renderPreorderBadge();

// to fix HELLO-371 where the max value is set to a wrong number by Globo's code:
//  - Watch any changes in the max attribute of preorder product's cart quantity
//    and apply new change with the correct value if needed.
//  - After the correct max is set, limit current value to max if it's more than max.

function getMaxPreorderQty(inputElement) {
  const productId = inputElement.dataset.productId;
  const variantId = inputElement.dataset.variantId;
  const hasDifferentPreorderSettingsPerVariant = !!variantId && !!Globo.Preorder.settings.preorderSettings.products[productId][variantId]
  const globoSettings = hasDifferentPreorderSettingsPerVariant
    ? Globo.Preorder.settings.preorderSettings.products[productId][variantId]
    : Globo.Preorder.settings.preorderSettings.products[productId];
  const globoLimit = JSON.parse(globoSettings.end_condition)
    .find(condition => condition.type === 'quantity')
    .condition;
  const inventoryQty = parseInt(inputElement.dataset.inventoryQty);
  const max = Math.abs(globoLimit - inventoryQty);
  return max;
}

function setQtyButtonsClickability(inputElement) {
  const qtyInput = inputElement.closest('quantity-input');
  const plusButton = qtyInput.querySelector('button[name="plus"]');
  const minusButton = qtyInput.querySelector('button[name="minus"]');
  const max = parseInt(inputElement.getAttribute("max"));
  const min = parseInt(inputElement.getAttribute("min"));

  const isMaxCalculated = inputElement.getAttribute('data-is-max-calculated');
  if (isMaxCalculated) {
    if (parseInt(inputElement.value) >= max) {
      plusButton.setAttribute("disabled", "disabled");
    } else {
      plusButton.removeAttribute("disabled"); 
    }
    if (parseInt(inputElement.value) <= min) {
      minusButton.setAttribute("disabled", "disabled");
    } else {
      minusButton.removeAttribute("disabled"); 
    }
  }
}

async function updateCartItemsQuantity(line, quantity) {
  const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  if (customElements.get("cart-items") && typeof cartItems.updateQuantity === 'function') {
    await cartItems.updateQuantity(line, quantity);
  } else {
    setTimeout(async () => {
      await updateCartItemsQuantity(line, quantity);
    }, 500);
  }
}

async function setQtyLimit(inputElement) {
  const isPreorder = inputElement.dataset.isPreorder;
  if (isPreorder) {
    const max = getMaxPreorderQty(inputElement);
    const latestMax = parseInt(inputElement.getAttribute("max"));
    if (latestMax !== max) {
      inputElement.setAttribute("max", max);
    }
    if (parseInt(inputElement.dataset.initialValue) > max) {
      const newValue = max;
      const line = inputElement.dataset.index;
      inputElement.value = newValue;
      await updateCartItemsQuantity(line, newValue);
    }
  }
  inputElement.setAttribute("data-is-max-calculated", true);
  setQtyButtonsClickability(inputElement);
}

const maxQtyObserver = new MutationObserver(mutations => {
  for (const mutation of mutations) {
    if (mutation.type === "attributes" && mutation.attributeName === "max") {
      setQtyLimit(mutation.target);
    }
  }
});

function initCartQuantityInputs() {
  const preorderQtyInputs = document.querySelectorAll('quantity-input input');
  preorderQtyInputs.forEach(qtyInput => {
    setQtyLimit(qtyInput).then(() => {
      maxQtyObserver.disconnect();
      maxQtyObserver.observe(qtyInput, { attributes: true });
    })
  });
}

initCartQuantityInputs();